import React, { lazy } from 'react'
import { useStructureMapping } from '../../../../shared/contexts/StructureContext'
const Plot = lazy(() => import('react-plotly.js'))

// Helper to truncate long strings so they fit on the axis
function truncate(str, n = 20) {
    if (!str) return '';
    return (str.length > n) ? str.substr(0, n - 1) + '...' : str;
}

function ViolinChart(props) {
    const dataKeyToValueMap = useStructureMapping(true)
    // Safe access to options
    const isHorizontal = props.options && props.options.horizontal;
    const showPoints = props.options && props.options.showPoints !== undefined ? props.options.showPoints : true;

    const series = props.series || []

    if (!series || series.length === 0) {
        return (
            <div className="med-vis-chart">
                <div className="med-no-data">You can select the categories to be displayed.</div>
            </div>
        )
    }

    // Map our series format to Plotly traces
    const traces = series.map((s) => ({
        type: 'violin',
        // If horizontal, data goes to x, otherwise y
        x: isHorizontal ? s.data : null,
        y: isHorizontal ? null : s.data,
        orientation: isHorizontal ? 'h' : 'v',
        // Truncate the name to prevent massive axis labels
        name: truncate(s.name) || '', 
        // Store the full name in customdata if you want to show it on hover
        customdata: s.name, 
        box: { visible: true },
        meanline: { visible: true },
        points: showPoints ? 'all' : false,
        // CHANGED: 'all' shows median, q1/q3, min/max, density, and individual points
        hoverinfo: 'all', 
    }))

    const layout = {
        title: { 
            text: props.name ? props.title : '', 
            x: 0.5 
        },
        yaxis: {
            title: {
                text: isHorizontal ? dataKeyToValueMap[props.options.yAxis] : dataKeyToValueMap[props.options.xAxis],
            },
            // key fix: allows the axis to resize itself to fit labels
            automargin: true, 
        },
        xaxis: {
            title: {
                text: isHorizontal ? dataKeyToValueMap[props.options.xAxis] : dataKeyToValueMap[props.options.yAxis],
            },
            // key fix: allows the axis to resize itself to fit labels
            automargin: true,
        },
        showlegend: false, // Kept your preference
        autosize: true,
        margin: {
             // Ensure there is enough padding around the chart
             l: 50, r: 50, b: 50, t: 50, pad: 4
        }
    }

    // Click handler
    function handleClick(event) {
        // Basic safety check
        if (!event || !event.points || event.points.length === 0) return

        const pt = event.points[0]
        const seriesIndex = pt.curveNumber
        const pointIndex = pt.pointNumber
        const s = series[seriesIndex]

        if (s && s.variables && s.variables[pointIndex]) {
            const variable = s.variables[pointIndex];
            
            // CRITICAL FIX 1: Wrap in setTimeout. 
            // This prevents 'gd.emit is not a function' errors by allowing 
            // Plotly to finish its event cycle before React unmounts/updates the component.
            setTimeout(() => {
                // CRITICAL FIX 2: Wrap variable in an array [variable].
                // VisualizationPage expects an array for 'popup.includes'.
                props.onDataClick && props.onDataClick([variable]) 
            }, 0);
        }
    }

    return (
        <div className="med-vis-chart">
            <Plot
                data={traces}
                layout={{ ...layout, height: 700 }}
                config={{ 
                    responsive: true, 
                    displayModeBar: true, // Useful to keep the bar to allow zooming reset manually
                    displaylogo: false 
                }}
                onClick={handleClick}
                style={{ width: '100%' }}
            />
        </div>
    )
}

export default ViolinChart